import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres80x/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres80x/labels')
  },
  getHisHeal (codempid) {
    if (isMock) return generator(mocker.hisHeal())
    return instance().get(endpoint + '/hres80x/hisHeal/' + codempid)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres80x/index.js